import { useState } from "react";
import type { ProcessingMode } from "../lib/cleanseSchema";

export function useMode() {
  const [mode, setMode] = useState<ProcessingMode>("cleanse");
  return { mode, setMode };
}
